import { featureItems, mediaItems } from '@/mocks/homeData';

export function FeaturesSection() {
  return (
    <section id="features" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">为什么选择黑料入口</h2>
          <p className="text-sm text-foreground-500">五大核心优势，打造最纯粹的吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featureItems.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl p-5 text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl mx-auto mb-4">
                <i className={`${item.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">独家深谈</h2>
          <p className="text-sm text-foreground-500">深度对话与专题策划，比爆料更深入的吃瓜视角</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative w-full h-[200px] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="flex items-center gap-1.5 text-background-50 text-xs">
                    <i className="ri-play-circle-fill text-lg"></i>
                    {item.duration}
                  </span>
                  <span className="text-background-50/80 text-xs">{item.views} 次播放</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}